export default __webpack_public_path__ + "static/TacosWithQuesoFrescoAndCornSalsa-9513b1cbe9470ba015afb4225448b5e2.jpeg";